import React from 'react';
import PropTypes from 'prop-types';
import {Button} from '@learningblocks/shared-components';

import style from './style.module.scss';

export function YesButton(props) {
  const className = `${style.yesButton} ${props.className}`;
  return (
    <Button
      className={className}
      tabIndex={props.tabIndex}
      onClick={props.onClickYes}>
      Yes
    </Button>
  );
}

YesButton.propTypes = {
  /**
   * classname for custom style of component
   */
  className: PropTypes.string,
  /**
   * callback function for button press yes
   */
  onClickYes: PropTypes.func.isRequired,
  /**
   * for keyboard accessibility
   */
  tabIndex: PropTypes.number,
};

YesButton.defaultProps = {
  className: '',
};
